export class GetBenchmarksRequest {
    IncludeVideoCards: boolean;
    IncludeCPUs: boolean;
    MissingValuesOnly: boolean;
}
